if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productForm && theme.mediaMatches.md) {
            // Score80 2026-10-09: on desktop show the bar whenever the Add to cart row is off screen (above or below),
            // not only once the whole (3,500 px) info column has scrolled away.
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      this.atcRow = this.productSection.querySelector('.js-product-form-main .product-info__add-to-cart');
      if (this.atcRow) {
        // Watch the Add to cart row itself (the form element also wraps hidden inputs and can be taller than the button row).
        this.productForm = this.atcRow;
        observer.observe(this.atcRow);
      } else if (this.productForm) observer.observe(this.productForm);

      this.addEventListener('click', (evt) => {
        const btn = evt.target.closest('[data-rww-sticky-add]');
        if (!btn) return;
        const main = this.productSection.querySelector('.js-product-form-main button[name="add"]');
        if (main && !main.disabled) {
          main.click();
          try { if (window.rwwTrack) window.rwwTrack('rww_sticky_add', { device: 'desktop' }); } catch (e) {}
        } else if (this.atcRow) {
          this.atcRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
